// @flow

export type RelaxItemType = {
  y: number,
  height: number,
  movable: boolean,
};

const overlap = function(item1 : RelaxItemType, item2 : RelaxItemType) : number {
  // item2 perfectly overlaps
  if(item1.y == item2.y && item1.height == item2.height) {
    return 1
  }
  // item2 overlaps from above
  else if(item2.y < item1.y && item2.y + item2.height > item1.y) {
    return 1;
  }
  // item2 overlaps from below
  else if(item2.y < item1.y + item1.height && item2.y + item2.height > item1.y + item1.height) {
    return -1;
  }
  // item2 does not overlap
  else {
    return 0;
  }
}

export default function(items : RelaxItemType[]) : RelaxItemType[] {
  let overlapping = true;
  let iter = 0;

  while(overlapping && iter < 50) {
    overlapping = true;

    for(let i = 0; i < items.length; i++) {
      for(let j = 0; j < items.length; j++) {
        if(i == j) continue;

        const direction = overlap(items[i], items[j]);

        if(items[i].movable) items[i].y += direction;
        if(items[j].movable) items[j].y -= direction;

        overlapping = overlapping || (direction != 0);
      }
    }

    iter += 1;
  }

  return items;
}
